import { getQuestionConfigLimits } from 'sharedParts/config/blockConfig';

import fieldStubFnMap from '../../../../config/FieldStubFnMap';

export default (data, type, keysToStubList) =>
  keysToStubList.reduce((stubbedData, key) => {
    stubbedData[key] = fieldStubFnMap[key](data[key], {
      ...getQuestionConfigLimits(type)[key],
    });

    return stubbedData;
  }, {});
